// useTemplates — the document templates available to a company.
//
// Feeds the invoice_template / receipt_template dropdowns on CompanyDetail and
// the template editor.
//
// COMPANY-SCOPED SINCE #62 PHASE 2. It used to read GET /v1/templates, the
// global builtin registry. That is now the wrong source: an operator can author
// their own templates (go-pim migration 0013), and a picker fed from the global
// route would not list the template they had just created — the single most
// confusing possible outcome of authoring one.
//
// GET /v1/companies/:id/templates returns the builtins AND the company's own,
// each tagged `built_in`, so there is still exactly one source of truth.
import { useQuery } from "@tanstack/react-query";

import { listCompanyTemplates } from "@/api/templates";
import { useAuth } from "@/store/auth";

export function useTemplates(companyId: string | undefined) {
  const status = useAuth((s) => s.status);
  return useQuery({
    queryKey: ["templates", companyId],
    queryFn: () => listCompanyTemplates(companyId!),
    enabled: status === "authenticated" && !!companyId,
    // Shorter than the old session-long cache: this list is no longer immutable
    // — an operator authoring a template needs it to appear in the picker on
    // the same visit, not after a reload.
    staleTime: 30_000,
  });
}
